import { Box, Typography, styled } from "@mui/material";
import { Outlet } from "react-router-dom";
import CustomTabs from "@/components/custom/custom-tabs";
import { NOTIFICATION_TABS } from "./data";

const RootWrapper = styled(Box)(({ theme }) => ({
  margin: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const NotificationOutlet = () => (
  <RootWrapper>
    <Box>
      <Typography variant="h6" fontWeight={600}>
        Notifications
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Message templates, SMS gateways, charges and delivery providers.
      </Typography>
    </Box>

    <CustomTabs tabs={NOTIFICATION_TABS} />

    <Outlet />
  </RootWrapper>
);

export default NotificationOutlet;